import { render, staticRenderFns } from "./deliverysetting.vue?vue&type=template&id=9f1d1bba&scoped=true"
import script from "./deliverysetting.vue?vue&type=script&lang=js"
export * from "./deliverysetting.vue?vue&type=script&lang=js"
import style0 from "./deliverysetting.vue?vue&type=style&index=0&id=9f1d1bba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1d1bba",
  null
  
)

export default component.exports